[ZoneTransfer]
LastWriterPackageFamilyName=Adobe.XD_pc75e8sa7ep4e
ZoneId=3
